"use strict";

export default class EventRegisterController
{
	/*@ngInject*/
	constructor($scope, $uibModalInstance, parent, ValidationService) // Valid 
	{
		this.$uibModalInstance = $uibModalInstance;
		this.validation = new ValidationService();

		this.e = parent.e;
		this.r = parent.r;
		
		this.d = {
			transponder: null,
			rank: null, 
			notransponder: false,
			tires: 0,
			frequency1: null,
			frequency2: null,
			car: null,
			motor: null,
			esc: null,
			battery: null,
			comments: null
		};

		$scope.$watch('vm.d.transponder', (value, oldvalue) =>
		{
			if (value !== oldvalue && value && value != "")
			{
				this.d.notransponder = false;
			}
		});
	}

	TransponderSelected(t)
	{
		if (t && t.number)
			this.d.transponder = t.number;
	};

	NoTransponderChanged(v)
	{
		if (v === true)
			this.d.transponder = null;
	};
		
	Close()
	{
		this.$uibModalInstance.dismiss(null);
	};

	Register(form)
	{
		this.showError = false;

		// Assign extra values in vm.extra to vm.d.extra
		// TODO:extra fields should be run on a different scope (probably in component scope?)
		this.d.extravalues = this.extra;
	
		if (!this.validation.checkFormValidity(form)) 
		{
			this.showError = true;
			return;
		}

		this.$uibModalInstance.close(this);
	}

	TransponderValidation()
	{
		if (!this.d.transponder || this.d.transponder == "")
			return this.d.notransponder === true;

		var i = parseInt(this.d.transponder, 10);
		if (i == this.d.transponder && i >= 1000000 && i <= 9999999)
		{
			this.d.transponder = i;
			return true;
		}

		return false;
	}
}



// WEBPACK FOOTER //
// ./client/app/frontend/event/eventregister.controller.js